import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeatureService } from 'app/features/feature.service';
import { Subject } from 'rxjs';
import { UserlaneService } from './userlane.service';

@Component({
  template: '',
  selector: 'hb-userlane',
})
export class UserlaneComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<boolean> = new Subject();

  constructor(
    private featureService: FeatureService,
    private userlaneService: UserlaneService,
  ) {}

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }
}
